import Box from "@mui/material/Box";

import AppIcon from "@/components/Core/AppIcon";

import { CRYPTO_ASSET_ICON_BY_CODE } from "./data";

// The gateway's own artwork wins; a code we ship an icon for comes second; and
// anything else gets its first two letters rather than a lookalike mark.
const AssetMark = ({ code, image }: { code: string; image?: string }) => {
  const icon = CRYPTO_ASSET_ICON_BY_CODE[code.toUpperCase()];

  if (image) {
    return (
      <Box
        component="img"
        src={image}
        alt=""
        sx={{ width: 22, height: 22, borderRadius: "50%", objectFit: "cover" }}
      />
    );
  }

  if (icon) return <AppIcon name={icon} size={22} />;

  return (
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        bgcolor: "action.selected",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: 0.2,
      }}
    >
      {code.slice(0, 2).toUpperCase()}
    </Box>
  );
};

export default AssetMark;
